import {
  getInvitationBackgroundSrc,
  normalizeInvitation,
  resolveInvitationFontFamily,
} from '../../lib/invitation';

function InvitationCanvas({
  invitation: rawInvitation,
  fullPage = false,
  embedded = false,
  className = '',
  children,
}) {
  const invitation = normalizeInvitation(rawInvitation);
  const hasBackground = !!getInvitationBackgroundSrc(invitation);
  const fontFamily = resolveInvitationFontFamily(invitation?.theme?.fontFamily);

  return (
    <div
      data-invitation-theme="light"
      data-invitation-font={invitation?.theme?.fontFamily || 'ubuntu'}
      className={[
        'invitation-canvas',
        hasBackground ? 'invitation-canvas--with-bg' : 'invitation-canvas--light',
        fullPage ? 'invitation-canvas--full-page' : '',
        embedded ? 'invitation-canvas--embedded' : '',
        className,
      ].filter(Boolean).join(' ')}
      style={{
        '--ba-invitation-font': fontFamily,
        fontFamily,
        ...(hasBackground ? { backgroundImage: `url(${getInvitationBackgroundSrc(invitation)})` } : {}),
      }}
    >
      {hasBackground && <div className="invitation-canvas__overlay" aria-hidden />}
      <div className="invitation-canvas__content">
        {children}
      </div>
    </div>
  );
}

export default InvitationCanvas;
